module.exports = __webpack_public_path__ + "icons/original/small/small-d4.465fbcbda569f002956eff6dbc525fba.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-d4.png
// module id = iXl1
// module chunks = app